import { useViewerIsSuperAdmin } from "@/lib/rights/use-viewer-is-baback-team";
import { Navigate, Outlet } from "react-router-dom";

/**
 * Layout guard for the /admin section.
 * Only accessible to users with services.superpowers.activated = true and MFA
 * enabled (BAB-3035).
 */
export default function AdminLayout() {
  const isBabackTeam = useViewerIsSuperAdmin();

  if (!isBabackTeam) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
